import React from 'react';
import $ from "jquery";
import axios from "axios";
import { Base64 } from 'js-base64';
import RenditionUrlGenerator from '../api/renditionUrlGenerator';
import commonStore from '../../store/commonStore.js';
import * as deviceInfoService from '../general/deviceInfoService';
import {getContextPath} from '../general/environmentService';
import _, { each, get, isEmpty, isEqual } from 'lodash';
import pushLogToBackend from '../general/pushLogToBackend';
import { osdetect } from "../../utils/general/deviceDetect";
import UserAgentUtils from '../../utils/general/userAgentUtils';
import { cv_openPageFromRendition } from '../../cvMobile/cvGeneral';
import { htmlPDFtoggleStatus } from '../../actions/commonStateAction';
import { getEPFTokensForGeneral, getStaticEPFAccessToken } from './EpfTokensUtils';



// export const getEpfToken = async () => {
//     let PORTALLayer: any = {};
//     PORTALLayer = window.parent.PORTAL || window.parent.parent.PORTAL;
    
//     try {
//         if(PORTALLayer?.EPF?.THIRDPARTY?.TOKENS?.tokenWrapper){
//             const token: any = await new Promise((resolve) => {
//                 PORTALLayer.EPF.THIRDPARTY.TOKENS.tokenWrapper(resolve);
//             })
//             console.log(token.access_token, "token");
            
//             return token.access_token;
//         }
  
//         return ''
//     } catch (e) {
//         console.error(e)
//     }
// }


const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
const COMPANY_UI_URL = window.HTML_RENDITION.initialData.html_origin + '/directory/eppublic/company23/';
export const ADA_Text = 'If you are visually impaired and would like to speak to a Citi representative regarding the details of the graphics in this document, please call USA 1-888-800-5008 (TTY: 711), from outside the US +1-210-677-3788.';

export const buildAdaAltText = (figureCaption: string, figureSource: string) => {
    try {
        let adaAltTxt = '';

        if (figureCaption) {
            adaAltTxt = figureCaption.trim();
        }

        if (figureSource) {
            adaAltTxt = adaAltTxt ? (adaAltTxt + ' ' + figureSource.trim()) : figureSource.trim();
        }

        adaAltTxt = adaAltTxt ? (adaAltTxt + ' ' + ADA_Text) : ADA_Text;

        adaAltTxt = adaAltTxt.replace(/&nbsp;/g,' ');
        adaAltTxt = adaAltTxt.replace( /\s\s+/g, ' ' );

        return adaAltTxt;
    } catch (error) {
        return '';
    }
};

// Get variables which backend exported. Refer to the rendition project rendition-js-constants.jsp
export const getRenditionJSConstants = () => {
    return commonStore.getState().asyncStateReducer.initialData;
};

export const base64urlEncode = (string: string) => {
    const base64 = btoa(string);
    const base64url = base64.replace(/\+/g, '-').replace(/\//g,'_').replace(/=+$/,'');
    return base64url
}

export const getCVFrameUrl = (menuCode: any, url: any, route: any) => {
    let cvFrameUrl = url;
    if (!!url && url.indexOf('__epftoken') === -1) {
        const epfTokensUrl = getEPFTokensForGeneral();
        if (!isEmpty(epfTokensUrl)) {
            url = addParam(url, '__epftoken', epfTokensUrl);
        }
    }
    try {
        if (!_.isEmpty(menuCode)) {
            if(_.isEqual(menuCode, 'RSCH_LANDING_PAGE')) {
                cvFrameUrl = RenditionUrlGenerator.URL_GENERATOR.environments(window.HTML_RENDITION.initialData.environment) +
                "/cv2/go/RSCH_LANDING_PAGE/" +
                base64urlEncode(
                  `__NAVIGATION_BASE64__cvr/citiresearchui/eppublic/${route}/iframe/` +
                  base64urlEncode(url)
                );
            } else {
                cvFrameUrl = RenditionUrlGenerator.URL_GENERATOR.environments(window.HTML_RENDITION.initialData.environment) + `/cv2/go/${menuCode}/` + base64urlEncode("__NAVIGATION_BASE64__" + url);
            }
            //for Safari Browser Internal 
            const epfTokenFrameUrl =  getStaticEPFAccessToken();
            if (!isEmpty(epfTokenFrameUrl)) {
                cvFrameUrl = cvFrameUrl + `?__epftoken=${epfTokenFrameUrl}`;
            }
        }
    } catch (error) {
        console.log(`Error:: getCVFrameUrl: menuCode: ${menuCode} and url: ${url}`, error);
    }
    return cvFrameUrl;
};

export const isAppInsideIFrame = () => {
    try {
        return window.self !== window.top;
    } catch (error) {
        return false;
    }
};

export const isAppInsideCViFrame = () => {
    try {
        if (!isAppInsideIFrame()) return false;
        const parentHostName = window.parent.location.hostname.toLowerCase();
        const parentPathName = window.parent.location.pathname.toLowerCase();
        // Return true if parent host name contains 'citivelocity' and parent path name does not contains 'hostedportlet'
        return parentHostName.indexOf('citivelocity') != -1
            && parentPathName.indexOf('hostedportlet') == -1;
    } catch (e) {
        return false;
    }
};

export const loopUntilTop = (fun: any, fallback = () => null) => {
    let tmp: any = window;
    while (tmp !== top) {
        try {
            tmp = tmp.parent;
            const result = fun(tmp);
            if (result !== undefined) return result;
        } catch (e) {
            console.error("Error in loopUntilTop", e);
            break;
        }
    }
    return fallback();
};

export const isAppInsideCVResearchUIiFrame = () => {
    return loopUntilTop(
        (tmp: any) => {
            if (tmp.location.pathname.indexOf("/cvr/citiresearchui/eppublic") > -1) return true;
        },
        () => false as any
    );
};

export const getDocumentViewService = () => {
    // implemented for the Mobile integration in citisBest frame in CPB
    // https://cedt-confluence.nam.nsroot.net/confluence/display/CPBInViewFramework/DocumentViewService
    return loopUntilTop(
        (tmp: any) => {
            if (tmp.DocumentViewService &&
                (UserAgentUtils.isMobile.Android() || UserAgentUtils.isMobile.iOS())
            ) {
                return tmp.DocumentViewService;
            }
        },
        () => false as any
    );
};

export const executeForCV = () => {
    if (
        isAppInsideCViFrame() &&
        !isAppInsideCVResearchUIiFrame() &&
        !isOpenedFromCitisBest
    ) {
        registerWindowUnload();
        adjustIFrameSettings();
        let cvSetTimeout: any = null;
        $(window.parent).resize(() => {
            clearTimeout(cvSetTimeout);
            cvSetTimeout = setTimeout(() => {
                const iframeEle: any = $(window.parent.document).find('#Main');
                const renditionFrameHeight = getRenditionFrameHeight(iframeEle);
                if (window.PORTAL.UI) {window.PORTAL.UI.CP.resizeFrameHeight(renditionFrameHeight);}
            }, 100);
        });
    }
};

export const registerWindowUnload = () => {
	const iframeEle = $(window.parent.document).find('#Main');
	const defaultScrollValue = 'auto';
	let originalValue: string = '';
	try {
		originalValue = iframeEle.attr('scrolling') || '';
		originalValue = _.isEmpty(originalValue) ? defaultScrollValue : originalValue;
	} catch (e) {
		originalValue = defaultScrollValue;
	}
	const unloadTask = () => {
		if (window.PORTAL.UI?.CP?.enableMainFrameScrolling) return;
		iframeEle.attr("scrolling", originalValue);
	};
	$(window).on("beforeunload", unloadTask);
	$(window).on("unload", unloadTask);
};

export const adjustIFrameSettings = () => {
	$('body').addClass('initial-height');
	const localQueue = [];
	localQueue.push(() => {
		if (window.PORTAL.UI && window.PORTAL.UI.CP.enableMainFrameScrolling) {
			window.PORTAL.UI.CP.enableMainFrameScrolling(true);
		}
		else {
			const iframeEle = $(window.parent.document).find('#Main');
			iframeEle.attr("scrolling","yes");
		}
	} );
	localQueue.push(() => {
        if (window.PORTAL.UI) window.PORTAL.UI.CP.stopAutoAdjust();
    });
	localQueue.push(() => {
		if (window.PORTAL.UI) {
            if (window.PORTAL.UI.CP.toggleMiniHeader) window.PORTAL.UI.CP.toggleMiniHeader(true);
        }
	} );
	localQueue.push(() => {
		const iframeEle: any = $(window.parent.document).find('#Main');
		const renditionFrameHeight = getRenditionFrameHeight(iframeEle);
		if (window.PORTAL.UI) window.PORTAL.UI.CP.resizeFrameHeight(renditionFrameHeight);
	});
	localQueue.push(() => {
        $('body').removeClass('initial-height');
    });
	localQueue.push(() => {
        if (parent.cv) parent.cv.any.desktop.navigation.MainFrame.removeLeftMargin();
    });

	// Few functions to identify if PORTAL JS is injected
	window.PORTAL = (typeof window.PORTAL == 'undefined') ? {} : window.PORTAL;
	if (window.PORTAL.executionQueue
			&& window.PORTAL.UI
			&& window.PORTAL.UI.CP
			&& window.PORTAL.UI.CP.toggleMiniHeader
			&& window.PORTAL.UI.CP.enableMainFrameScrolling) {
		// PORTAL JS is injected, so simply execute all the functions in local queue
		$.each(localQueue, (index, func) => {
			try {
				func();
			} catch (e){
				const msg = 'Rendition Frontend PORTAL.executionQueue =====> Exception in localQueue execution ...' + e;
				const params = {
						'msg': msg,
						'doc_id': window.HTML_RENDITION.doc_id,
						'type': 'remote_log'
				};
				pushLogToBackend(params);
			}
		});
	}
	else {
		// PORTAL JS is not yet injected, so store the localQueue to the executionQueue
		// "PORTAL.executionQueue" will be executed by PORTAL once injected
		window.PORTAL.executionQueue = localQueue;
	}
};

export const escapeHTML = (str: string) => {
    try {
       /*   if(str) {
              str = str.replace(/&/g, '&amp;').
                          replace(/</g, '&lt;').
                          replace(/>/g, '&gt;').
                          replace(/'/g, '&#39;').
                          replace(/"/g, '&quot;');
       }
       return str;*/
       return $('<div></div>').text(str).html();
    } catch (e) {
        return str;
    }
};

export const escapeLessThanSign = (str: string) => {
    try {
       if (str) {
        str = str.replace(/</g, '&lt;');
       }
       return str;
    } catch (e) {
        return str;
    }
};

export const documentsPath = () => {
    return '/rendition/eppublic/akpublic/documents/';
};

export const doc_app_version = () => {
    return window.HTML_RENDITION.initialData.environment.toUpperCase() == 'LOCAL'
    ? ''
    : commonStore.getState().asyncStateReducer.initialData.doc_app_version;
};

export const documentsPath_version = () => {
    return documentsPath() + doc_app_version() + '/';
};

export const isBlackberryMode = () => {
    try {
        return (commonStore.getState().asyncStateReducer.initialData.device_prefix === 'bbry_');
    } catch (e) {
        return false;
    }
};

export const parseToBoolean = (str: string) => {
    try {
        if (_.isNull(str) ) {
            return null;
        }
        if (_.isUndefined(str)) {
            return false;
        }

        let temp = _.trim(str);
        if (!temp || temp.length === 0) {
            return false;
        }

        temp = temp.toLowerCase();
        return $.parseJSON(temp);
    } catch (e) {
        return false;
    }
};

// Original name is HTML_RENDITION.isAggregateProduct, update the name is because most time we are using compendium to discribe point/roundup/golobaliser.
export const isCompendiumProduct = () => {
    const productType = getRenditionJSConstants().productType;
    return productType === 'globaliser' || window.HTML_RENDITION.isRoundup || window.HTML_RENDITION.isPoint || window.HTML_RENDITION.isGlobalizer;
};

// isPPTOrLandscape
export const isPresentation = () => {
    const productType = getRenditionJSConstants().productType;
    const docFileType = getRenditionJSConstants().docFileType;
    return (productType === 'ppt' || productType === 'landscape' || docFileType === 'PPT');
};

// is audio or video
export const isMedia = () => {
    const productType = getRenditionJSConstants().productType;
    return (productType === 'audio' || productType === 'video');
};

// Important!!! we only get one time is enougth, when open the website!
const _time = new Date().getTime();
export const timestamp = () => {
    return _time;
};

export const addParam = (url: string, parameterName: string | boolean, parameterValue: string | boolean) => {
    if (parameterValue == undefined || parameterValue === "" || parameterValue == 'null') {
        return url;
    }
    url += (url.indexOf('?') != -1) ? "&" : "?";
    url += parameterName + "=" + parameterValue;
    return url;
};

export const getRenditionMultimediaURL = (url: string, autoscale: string | boolean, autoplay: string | boolean, poster: string | boolean) => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    let multimediaUrl = "https://" + url.split('://')[1];
    if (autoscale) multimediaUrl = addParam(multimediaUrl, "autoscale", autoscale);
    if (autoplay) {
        multimediaUrl = addParam(multimediaUrl, "autoplay", autoplay);
    }
    if (poster) {
        multimediaUrl = addParam(multimediaUrl, "poster", poster);
    }
    const _url = (function () {
        let _tmpUrl = "";
        if (window.btoa)
            _tmpUrl = window.btoa(multimediaUrl);
        else if (Base64)
            _tmpUrl = Base64.encode(multimediaUrl);
        else
            return _tmpUrl;
        if (window.HTML_RENDITION.initialData.isPublic && _HTML_RENDITION.urlParameters.preview_mode){
            return RenditionUrlGenerator.URL_GENERATOR.generateByCGIMultimediaURL(_tmpUrl, _HTML_RENDITION.doc_id, _HTML_RENDITION.environment);
        }
        return RenditionUrlGenerator.URL_GENERATOR.generateByMultimediaURL(_tmpUrl, _HTML_RENDITION.doc_id, _HTML_RENDITION.environment); // HTML_RENDITION.doc_id, HTML_RENDITION.environment
    })();
    if (_url) {
        multimediaUrl = _url;
    } else {
        if (_HTML_RENDITION.videoURLParam) { // HTML_RENDITION.videoURLParam
            multimediaUrl = addParam(multimediaUrl, "RI", _HTML_RENDITION.videoURLParam); // HTML_RENDITION.videoURLParam
        }
    }
    if (_HTML_RENDITION.urlParameters.preview_mode) {
        multimediaUrl = addParam(multimediaUrl, "preview_mode", _HTML_RENDITION.urlParameters.preview_mode);
        multimediaUrl = addParam(multimediaUrl, "productCode", _HTML_RENDITION.urlParameters.productCode);
    }
    return multimediaUrl;
};

export const addParentDocDataParam = (url: string) => {
    url += (url.indexOf('?') != -1) ? '&' : '?';
    url += 'parentDocData=' + commonStore.getState().asyncStateReducer.initialData.parentDocData;
    return url;
};

export const isAppInsideCPBiFrame = () => {
    const _window: any = window;
    if (!isAppInsideIFrame()) return false;
    try {
        if (typeof (_window.parent.CPB_PWM) === "object") {
            // Return true if parent's CPB_PWM exist
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
};

export const isAppInsidePWMiFrame = () => {
    let result = false;
    const _window: any = window;
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    try {
        if (!isAppInsideIFrame()) return false;
        if ((typeof (_window.parent.CPB_PWM) === "object") && ((_window.parent.CPB_PWM.UI["vendor-issuer"]).indexOf('pwm_inv') != -1)) {
            // Return true if parent's CPB_PWM exist
            return true;
        } else {
            const pwm_investment_url = _HTML_RENDITION.pwmInvestmentUrl;
            result = pwm_investment_url.indexOf('investments') != -1;
            return result && (_HTML_RENDITION.parseToBoolean(_HTML_RENDITION.validPWMBroker));
        }
    } catch (e) {
        return false;
    }
};

export const getRenditionFrameHeight = (iframeEle: JQuery) => {
	let renditionFrameHeight = 400;
	const availableFrameHeight = ($(window.parent).height() || 0) - (iframeEle.offset() || { top: 0 }).top - 20; // (for clearance)
	renditionFrameHeight = (availableFrameHeight > renditionFrameHeight ) ? availableFrameHeight : renditionFrameHeight;
	return renditionFrameHeight;
};

export const isChromeFrame = () => {
    const _window: any = window;
    try {
        return (_window.externalHost != undefined);
    } catch (e) {
        return false;
    }
};

export const isCPServer = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    const cpServer = _HTML_RENDITION.urlParameters['cp-server'];
    return cpServer && cpServer != '';
};

export const loadingImageURL = () => {
    let url: string = commonStore.getState().asyncStateReducer.initialData.documentsPath_version + 'img/ajax_loader_blue_32.gif?ts=' + commonStore.getState().asyncStateReducer.initialData.buildTimeStamp;
    if (isCPServer()) {
        url = addCPServerParam(url);
    }
    return url;
};

export const getDocumentLink = function (encodedDocId: string) {
    return addParentDocDataParam("/rendition/eppublic/documentService/" + encodedDocId);
};

export const getCGIDocumentLink = function (encodedDocId: string) {
    return addParentDocDataParam(window.HTML_RENDITION.initialData.publicWebBase + "/" + encodedDocId);
};

export const addCPServerParam = (url: string) => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    url = addParam(url, "cp-server", _HTML_RENDITION.urlParameters['cp-server']);
    return url;
};

// for avoid jquery offset().top in cv frame get error value, this fn can also work in standalone page
$.fn.extend({
    cvOffSet() {
        // target in here should be js obj
        const _this: any = this;
        let top = 0;
        let left = 0;
        let target = _this[0];

        // when target is body it offsetParent will be null,so can match cvWindowTarget
        while (target?.offsetParent) {
            top += target.offsetTop;
            left += target.offsetLeft;
            target = target.offsetParent;
        }

        return {
            top,
            left,
        };
    }
});

export const bodyScrollTo = (scrollEleName: string) => {
    const scrollTo = $(`#${scrollEleName}`).cvOffSet().top;
    $('html, body').animate({
        scrollTop: scrollTo - 68  // Scroll to the anchor location, 68px is the top bar's height
    }, {
        // Tested, 2 second is long enough for loading some static resource
        duration: 2000,
        // At each animation step, check whether the target has moved.
        step: (now, fx) => {
                // Where is the target now located on the page?
                // i.e. its location will change as images etc. are lazy loaded
                const newOffset = $(`#${scrollEleName}`).cvOffSet().top;
                // If where we were originally planning to scroll to is not
                // the same as the new offset (newOffset) then change where
                // the animation is scrolling to (fx.end).
                if (fx.end !== newOffset)
                    fx.end = newOffset - 68;
        }
    });
};

export const bodyScrollToByClassName = (scrollEleName: string) => {
    const scrollTo = $(`.${scrollEleName}`).cvOffSet().top;
    $('html, body').animate({
        scrollTop: scrollTo - 68
    }, {
        duration: 2000,
        step: (now, fx) => {
                const newOffset = $(`.${scrollEleName}`).cvOffSet().top;
                if (fx.end !== newOffset)
                    fx.end = newOffset - 68;
        }
    });
};

export const scrollToHashAnchor = () => {
    let anchor = commonStore.getState().asyncStateReducer.initialData.urlParameters['anchor'] || commonStore.getState().asyncStateReducer.initialData.anchor;
    if (_.isEmpty(anchor)) {
        return;
    }
    anchor = anchor?.indexOf('#') == 0 ? anchor.substring(1) : anchor;
    if (/^[a-zA-Z0-9_-]+$/.test(anchor)) {  //  hash string contains letters, numbers, _ and -, validate anchor string doesn't contain strange char
        if (_.startsWith(anchor, "rendition_table_")){
            if ($(`#${anchor}`).length > 0){
                bodyScrollTo(anchor);
            } else {
                bodyScrollToByClassName(anchor);
            }
        } else {
            (_.startsWith(anchor, "msword-") || _.startsWith(anchor, "bullBear_") || _.startsWith(anchor, "instant-poll-") || _.isEqual(anchor, "statistical-abstract") || _.isEqual(anchor, "wp-block-research-ratings-block")) ? bodyScrollToByClassName(anchor) : bodyScrollTo(anchor);
        }
    }
};

export const openAnalystPage = (analystNumber: string, target?:string) => {
    const analystPageUrl = `/directory/eppublic/analyst/#/${analystNumber}/overview`;
    const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
    const menuCode = commonStore.getState().commonStateReducer.menuCode;
    const environment = window.HTML_RENDITION.initialData.environment;
    const analystUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + analystPageUrl;
    const updatedAnalystUrl = getCVFrameUrl(menuCode, analystUrl, 'author_dir');
    if (isBloomBerg()) {
        openAnalystPageForBloomBerg(analystNumber);
        return;
    }
    if (window.HTML_RENDITION.initialData.templateCode?.toLowerCase() === 'citiexpress' && (parent as any).CVR_COMMON_API) {
        (parent as any).CVR_COMMON_API?.getEmitter().emit("nav",{},`/citi_express/iframe/${encodeURIComponent(btoa(analystPageUrl))}`);
        return;
    }
    openPageFromRendition(updatedAnalystUrl, target);
};

export const openAnalystPageForBloomBerg = (analystNumber: string) => {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;

    const channel = _HTML_RENDITION.channel || 'citivelocity';
    const subChannel = _HTML_RENDITION.sub_channel || '';
    const platformId = window.HTML_RENDITION.initialData.platform || '';

    let dataStr = !_.isEmpty(channel) ? 'channel=' + channel : '';
    if (!_.isEmpty(dataStr)) {
        dataStr = dataStr + '&';
    }

    dataStr = dataStr + !_.isEmpty(subChannel) ? 'subChannel=' + subChannel : '';
    if (!_.isEmpty(dataStr)) {
        dataStr = dataStr + '&';
    }

    dataStr = dataStr + 'platformId=' + platformId + '&analystId=' + analystNumber + '';
    const url = "/directory/eppublic/analyst?data=" + window.btoa(dataStr);
    window.location.href = url;
    return;
};

export const openCompanyPage = (ticker: string, tileName?: string | undefined,  target?: string) => {
    const url = getCVFrameUrl(commonStore.getState().commonStateReducer.menuCode, COMPANY_UI_URL + (ticker? ticker :'') + (tileName ? `/#${tileName}` : ''), 'company_dir');
    openPageFromRendition(url, target);
};

export const openPageFromRendition = function (url: string, target?: string) {
    if (isCVMobileApp()) {
        return cv_openPageFromRendition(url);
    }
    if(target && target == '_blank') {
        window.open(url, target);
        return;
    }
    if (isAppInsideCViFrame() && !isAppInsideCVResearchUIiFrame()) {
        const dest = !parent.prtl ? parent.parent.prtl : parent.prtl;
        const activeMenu = dest.navigation.getCurrentMenuNode();
        dest?.navigation?.go?.(activeMenu, url);
        return;
    }
    if (target) window.open(url, target);
    else window.location.href = url;
};

export const getTitleHeadline = (docId: string, title: string, headline: string, docHeaderJsonData: any) => {
    let headlineTitle = '';
    if (!!docHeaderJsonData.issuerPage.related_doc_ids && !!docHeaderJsonData.issuerPage.related_doc_ids.titleOptions) {
        const relatedDocIdsArray = docHeaderJsonData.issuerPage.related_doc_ids.ids.split(',');
        const relatedDocIdsTitleOptionsArray = docHeaderJsonData.issuerPage.related_doc_ids.titleOptions.split(',');
        const relatedDocIdsHeadlineOptionsArray = docHeaderJsonData.issuerPage.related_doc_ids.headlineOptions.split(',');
        let docIndex = -1;
        if (deviceInfoService.isIE()) {
            for (let k = 0; k < relatedDocIdsArray.length; k++) {
                if (docId == relatedDocIdsArray[k]) {
                    docIndex = k;
                    break;
                }
            }
        } else {
            docIndex = relatedDocIdsArray.indexOf(docId);
        }
        let titleOption = '';
        let headlineOption = '';
        if (docIndex > -1) {
            titleOption = relatedDocIdsTitleOptionsArray[docIndex];
            headlineOption = relatedDocIdsHeadlineOptionsArray[docIndex];
        } else {
            return _.unescape(title);
        }

        if (titleOption?.toUpperCase() == 'TRUE') {
            headlineTitle = _.unescape(title);
        }
        if (headlineOption?.toUpperCase() == 'TRUE') {
            if (!headlineTitle) {
                headlineTitle = headline ? _.unescape(headline) : _.unescape(title);
            } else {
                headlineTitle = headlineTitle + ': ' + _.unescape(headline);
            }
        }
    } else {
        headlineTitle = _.unescape(title);
    }
    return headlineTitle;
};

export const isValidEmail = (str: string) => {
    const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return reg.test(str);
};

export const isPreview = () => {
    return commonStore.getState().asyncStateReducer.initialData.urlParameters.preview_mode;
};

export const isStaticHtmlMode = () => {
    return window.HTML_RENDITION.initialData.isStaticHtmlExport || window.HTML_RENDITION.initialData.isStaticHtml;
};

export const isAuthPreview = () => {
    return commonStore.getState().asyncStateReducer.initialData.urlParameters.isAuthPreview;
};

export const isStaticMode = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    return !_.isEmpty(_HTML_RENDITION.mode)
        && _HTML_RENDITION.mode == 'static_view';
};

export const isLiteView = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    return !_.isEmpty(_HTML_RENDITION.subMode)
        && _HTML_RENDITION.subMode == 'lite_view';
};

export const isCitiExpress = () => {
    return window.HTML_RENDITION.initialData.templateCode?.toLowerCase() === 'citiexpress';
};

window.HTML_RENDITION.enableMagnifier = true;
window.HTML_RENDITION.initZoom = false;
window.HTML_RENDITION.initZoomEvent = false;
window.HTML_RENDITION.magnifierToolId = 0;
window.HTML_RENDITION.naturalImageWidths = {};
window.HTML_RENDITION.naturalImageHeights = {};
export const downloadImage = (imgSrc: string) => {
    const image = new Image();
    image.src = imgSrc;
    image.onload = () => {
        window.HTML_RENDITION.naturalImageWidths[imgSrc] = image.width;
        window.HTML_RENDITION.naturalImageHeights[imgSrc] = image.height;
    };
};

// Expiry Link or named Timed Link
export const isTimedLinkAvailable = window.HTML_RENDITION.initialData.isTimedLinkAvailable || false;
window.HTML_RENDITION.linkId = window.HTML_RENDITION.initialData.linkId || '';

export const getLinkId = () => {
    const timedLinkAvailablity = window.HTML_RENDITION.initialData.isTimedLinkAvailable || false;
    const linkId = ($ && $.trim) ? $.trim(window.HTML_RENDITION.linkId) : window.HTML_RENDITION.linkId;
    if (timedLinkAvailablity === true && linkId && linkId != ''){
        return linkId;
    }
    return '';
};

export const getLinkIdParam = () => {
    const timedLinkAvailablity = window.HTML_RENDITION.initialData.isTimedLinkAvailable || false;
    if (timedLinkAvailablity === true && getLinkId()){
        return 'linkId=' + getLinkId() + '&';
    }
    return '';
};

window.HTML_RENDITION.mathjax_ready_to_typeset = true;

// ||Start|| below code only for infographic
window.HTML_RENDITION.infographicEventNotRegist = true;
window.HTML_RENDITION.infographicNo = 0;
window.HTML_RENDITION.cvWindowTarget = (deviceInfoService.isIE() && isAppInsideIFrame()) ? $('body') : $(window);
// This function is only for infographic
window.HTML_RENDITION.windowScroll = function () {
    window.HTML_RENDITION.cvWindowTarget.on('scroll', _.debounce(handInfographicScrollEvent, 200));
};

const handInfographicScrollEvent = () => {
    const top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    for (const i in window.HTML_RENDITION.infographicPositionArr) {
        if (top >= window.HTML_RENDITION.infographicPositionArr[i] - window.HTML_RENDITION.infogSection && top <= window.HTML_RENDITION.infographicPositionArr[i] + window.HTML_RENDITION.infogSection) {
            window.HTML_RENDITION.infographicNo = i;
            if (document.querySelectorAll('.infographic_iframe')[window.HTML_RENDITION.infographicNo]) {
                try {
                    const contentWindow = (document.querySelectorAll('.infographic_iframe')[window.HTML_RENDITION.infographicNo] as any).contentWindow;
                    if (contentWindow.INFOGRAPHIC !== undefined) {
                        contentWindow.INFOGRAPHIC.canStartAnamite = true;
                        console.log('!!!!!Start infographic animation #NO', window.HTML_RENDITION.infographicNo);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }
    }
};
// ||End||

export const showLoadMask = () => {
    $('body').addClass('showloadmask');
    $('#globalLoadingMask').show();
};

export const hideLoadMask = () => {
    $('body').removeClass('showloadmask');
    $('#globalLoadingMask').hide();
};

export const getOpenDocumentLink = (docId: string) => {
    const base = window.HTML_RENDITION.initialData.isPublic ? window.HTML_RENDITION.initialData.publicWebBase : '/rendition/eppublic/uiservices/open_document';
    return addParentDocDataParam(base + '?doc_id=' + docId);
};

export const getDetachUrl = (detachType: string, popupHeader: string, index?: number | string) => {
    const staticData = commonStore.getState().asyncStateReducer.initialData.staticData;
    let detachUrl = window.HTML_RENDITION.initialData.isPublic ? getCGIDocumentLink(staticData) : getDocumentLink(staticData);
    if (!staticData || staticData == 'null') {
        detachUrl = getOpenDocumentLink(window.HTML_RENDITION.doc_id);
    }
    detachUrl = addParam(detachUrl, 'popup', 'true');
    detachUrl = addParam(detachUrl, 'detachType', detachType);
    detachUrl = addParam(detachUrl, 'popupHeader', popupHeader);
    if (getRenditionJSConstants().urlParameters.isReact){
        detachUrl = addParam(detachUrl, 'isReact', 'true');
    }
    if (!_.isUndefined(index)){
        detachUrl = addParam(detachUrl, 'index', index.toString());
    }
    return detachUrl;
};

export const addFinSumParam = (detachUrl: string) => {
    let result = detachUrl;
    let companyMetaData;

    const docHeaderSectionJson = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    const multiCompanyMetaData = commonStore.getState().commonStateReducer.multiCompanyMetaData;
    const finSumData = commonStore.getState().asyncStateReducer.finSumData;

    if (_.isEmpty(multiCompanyMetaData)) {
        companyMetaData = docHeaderSectionJson.metadata;
    } else {
        companyMetaData = multiCompanyMetaData;
    }

    const index = hasUrlParam(detachUrl, "index");
    const finsumTabIndex = !_.isUndefined(index) ? index : '0';

    result = addParam(result, "finsumTabIndex", finsumTabIndex);
    result = addParam(result, 'compName', encodeURIComponent(finSumData.FinancialSummary.FinancialSummaryTitle));
    result = addParam(result, 'compId', '1');
    result = addParam(result, 'ratingBlockIndex', '-1');
    result = addParam(result, 'compCode', encodeURIComponent(companyMetaData.companyCode));

    return result;
};

export const hasUrlParam = (url: string, name: string) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getHeatMapDataUrl = () => {
    return '/renditionWebServices/eppublic/uiservices/submissionRequests/heatmap.json?expandDataJson=true&id=';
};

export const getClickCountDataUrl = () => {
    return 'https://rmis-visualizer-uat.nam.nsroot.net:41566/visualizer-engine/api/dataService/gethtmleventclickscount?id=';
};

export const deferred = (condition: boolean | string, delay: number, maxWait: number) => {
    const defer = $.Deferred();
    let currentWait = 0;
    let timerFunction: any = null;
    condition = condition || true;
    if (typeof condition == 'string'){
        condition = (condition == 'true');
    }
    delay = delay || 100;

    setTimeout( timerFunction, delay );

    timerFunction = () => {
        currentWait += delay;
        if (condition) {
            defer.resolve("success");
            return;
        }
        else if (maxWait && currentWait > maxWait) {
            defer.reject("Failed. MaxWait reached.");
            return;
        }
        defer.notify("pending");
        setTimeout(timerFunction, delay);
    };
    return defer.promise();
};

export const shouldShowSearch = () => {
	return (!(osdetect && ( osdetect.detectSmartPhone() || osdetect.detectTablet() ))
                && parseToBoolean(getRenditionJSConstants().show_search));
};

export const isTabletOrPhone = () => {
	return osdetect && ( osdetect.detectSmartPhone() || osdetect.detectTablet() );
};

export const isAndroidTabletOrPhone = () => {
	return osdetect && osdetect.detectAndroid();
};

export const isIOSTabletOrPhone = () => {
	return osdetect && (osdetect.detectIphoneOrIpod() || osdetect.detectIpad());
};

export const getCvMenuCode = () => {
	return (parent.prtl != undefined && parent.prtl.navigation != undefined) ? parent.prtl.navigation.getCurrentMenuNode().getShortcut() : '';
};
export const getRelativePath = (absoluteUrl: string) => {
	// remove "https://" or "http://"
	let relativeAnchor = absoluteUrl.replace(/^https?:\/\//,'');
	const arr = relativeAnchor.split('/');
	arr.shift();
	relativeAnchor = '/' + arr.join('/');
	return relativeAnchor;
};

export const changeCVUrl = (docUrl: string) => {
	const prtl = !parent.prtl ? parent.parent.prtl : parent.prtl;
	prtl.navigation.go(getCvMenuCode(), docUrl);
};

export const getHostName = (url: string) => {
	const a = document.createElement('a');
	a.href = url;
	return a.hostname;
};

export const getPathname = (url: string) => {
    // because window.location.pathname is different between IE and Chrome, add this function
    if (_.startsWith(url, '/')) {
        return url;
    }

    const hostname = getHostName(url);
    return url.split(hostname)[1];
};

export const referrer = () => {
	return window.document.referrer;
};

export const isParentDomainRegistered = () => {
    try {
    	const domainPatterns = getRenditionJSConstants().rendition_parent_domains_patterns.split(",");
    	let isRegistered = false;
    	const parentHostName = getHostName(referrer());
    	$.each(domainPatterns, (index, domainPattern) => {
    		const pattern = new RegExp(domainPattern, "i");
    		if (pattern.test(parentHostName)
    				|| pattern.test("any")) {
    			isRegistered = true;
    			return false;
    		}
    	});
    	return isRegistered;
    } catch (e) {
        return true;
    }
};

export const decodeHTMLCode = (str: string) => {  // Example: &apos;
    const div = document.createElement("div");
    div.innerHTML = str;
    return typeof div.textContent !== 'undefined' ? div.textContent : div.innerText;
};

export const isCVMobileApp = () => {
    return getRenditionJSConstants().controller_prefix == 'cvmobile_';
};

export const isCVLink = (url: string) => {
    const cvHost = 'citivelocity.com';
    if (!url) {
        return false;
    }
    if (url.charAt(0) == '/' || url.split('?')[0].indexOf(cvHost) > -1) {
        return true;
    }
    return false;
};

export const getScrollBarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
};

export const storeDeviceIdInEvercookie = () => {
    const cookieValue = getRenditionJSConstants().deviceId;
    if (cookieValue && cookieValue != 'null') {
        // let ecURL = '/rendition/eppublic/akpublic/evercookie/js/evercookie_crisp.js'; // for local test
        let ecURL = 'externalJS/evercookie_crisp.js';   // '/rendition/eppublic/akpublic/reactui/externalJS/evercookie_crisp.js';
        ecURL = addParam(ecURL, "ts", getRenditionJSConstants().buildTimeStamp);
        if (isCPServer()) ecURL = addCPServerParam(ecURL);
        $.getScript(ecURL, () => {
            window.jQuery = $;
            const ec = new (window as any).evercookie();
            ec.set(getRenditionJSConstants().deviceCookieName, cookieValue);
        });
    }
};

export const executeAfterRenderSteps = () => {
	window.HTML_RENDITION.isHTMLRenderedFully = true;
	$(document).trigger('isHTMLRenderedFully');
};

export const uniqueId = () => {
	return window.HTML_RENDITION.initialData.isStaticHtmlExport && _.uniqueId('root-');
};

/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
 */
export const isBase64Valid = (src: string) => {
    if (typeof src !== 'string')
        return false;
    if (src === '' || src.trim() === '') { return false; }
    try {
        return Base64.btoa(Base64.atob(src)) == src;
    } catch (err) {
        return false;
    }
};

/**
 * Rendition provide a function to call Bloomberg's API.
 * It needs Rendition sending url.
 * Only need Rendition main page's link url using this Bloomberg's API, LHS menu and RHS panel will not do this.
 * @param {String} docUrl Mainpage's link url
 */
export const isBloomBerg = () => {
    return window.HTML_RENDITION.initialData.bloombergPlatformId == window.HTML_RENDITION.initialData.platform;
};

export const BloomBergExecution = (docUrl: string) => {
    console.log('BloomBergExecution ::docUrl::', docUrl);
    const docHeaderSectionJson = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    console.log('Inside BloomBergExecution');
    try {
        if ((window as any).BB_NavigateById) {
            (window as any).BB_NavigateById(docHeaderSectionJson.metadata.researchId);
        } else {
            window.open(docUrl);
        }
    } catch (e) {
        window.open(docUrl);
    }
};

export const BloomBergExecutionWithDocId = (docId: string, docUrl: string, newTab: boolean) => {
    console.log('BloomBergExecutionWithDocId ::docId::docUrl::', docId, docUrl);

    if (!isBloomBerg() || _.isEmpty(docId)) {
        console.log('BloomBergExecutionWithDocId not BBG or DocId is empty', docId);
        openDoucmentForBBGWithDocUrl(docUrl, newTab);
        return;
    }

    $.ajax({
        type: "GET",
        url: "/rendition/uiws/eppublic/V1/docIdTranslate.json?docId=" + docId,
        dataType: 'json',
        success: (data) => {
            if (data && data.researchId) {
                console.log('BloomBergExecutionWithDocId data.researchId', data.researchId);
                try {
                    if ((window as any).BB_NavigateById) {
                        (window as any).BB_NavigateById(data.researchId);
                    } else if (!!window.parent && (window.parent as any).BB_NavigateById) {
                        (window.parent as any).BB_NavigateById(data.researchId);
                    } else if (!!window.top && (window.top as any).BB_NavigateById) {
                        (window.top as any).BB_NavigateById(data.researchId);
                    } else {
                        console.log('BloomBergExecutionWithDocId ::no BB_NavigateById');
                        openDoucmentForBBGWithDocUrl(docUrl, newTab);
                    }
                } catch (e) {
                    console.log('BloomBergExecutionWithDocId ERROR::no BB_NavigateById');
                    openDoucmentForBBGWithDocUrl(docUrl, newTab);
                }
            } else {
                console.log('BloomBergExecutionWithDocId ::no data.researchId', docId);
                openDoucmentForBBGWithDocUrl(docUrl, newTab);
            }
        },
        error: (e) => {
            console.log('BloomBergExecutionWithDocId ERROR::docIdTranslate.json', docId);
            openDoucmentForBBGWithDocUrl(docUrl, newTab);
        }
    });
};

const openDoucmentForBBGWithDocUrl = (docUrl: string, newTab: boolean) => {
    if (newTab) {
        window.open(docUrl);
    } else {
        window.location.href = docUrl;
    }
};

export const checkDocIdAndOpenPubicationForBBGWithDocumentURL = (docUrl: string, newTab: boolean) => {
    console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL ::docUrl::', docUrl);
    const handledUrlValue: any = encodeURIComponent(docUrl.trim().replace(/\/#go\//i, '/go/'));
    $.ajax({
        type: "GET",
        url: "/rendition/uiws/eppublic/V1/docIdTranslate.json?url=" + handledUrlValue,
        dataType: 'json',
        success: (data) => {
            if (data && data.researchId){
                console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL data.researchId', data.researchId);
                try {
                    if ((window as any).BB_NavigateById) {
                        (window as any).BB_NavigateById(data.researchId);
                    } else if (!!window.parent && (window.parent as any).BB_NavigateById) {
                        (window.parent as any).BB_NavigateById(data.researchId);
                    } else if (!!window.top && (window.top as any).BB_NavigateById) {
                        (window.top as any).BB_NavigateById(data.researchId);
                    } else {
                        console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL ::no BB_NavigateById');
                        openDoucmentForBBGWithDocUrl(docUrl, newTab);
                    }
                } catch (e) {
                    console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL ERROR::no BB_NavigateById');
                    openDoucmentForBBGWithDocUrl(docUrl, newTab);
                }
            } else {
                console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL ::no data.researchId', docUrl);
                openDoucmentForBBGWithDocUrl(docUrl, newTab);
            }
        },
        error: (e) => {
            console.log('checkDocIdAndOpenPubicationForBBGWithDocumentURL ERROR::docIdTranslate.json', docUrl);
            openDoucmentForBBGWithDocUrl(docUrl, newTab);
        }

    });
};

/**
 * Execute Light Rendition's link in main page.
 * For Video/Audio, will hide whole "Related Publication(s)" part.
 * For All rendition docs, the main page's link will be disabled.
 * Rendition doesn't handle any specific light rendition's code, only this requirement.
 * Light rendition is only controlled by entitlement, but this requirement no related entitlement, so using code control.
 * JIRA C150113-49910
 * @return {boolean}
 */
export const isHTMLLightRendition = () => {
    return getRenditionJSConstants().html_light_rendition;
};

/**
 * Rendition page (Standalone Video) will hide "Copy URL" in CBOL
 * CBOL platform id is 149
 * JIRA C150113-49876
 */
export const isGCB_CBOL = () => {
    const CBOL_platform_id = 149;
    return getRenditionJSConstants().platform == CBOL_platform_id;
};

export const isSALE_FORCE = () => {
    const SAFE_FORCE_platform_id = 150;
    return getRenditionJSConstants().platform == SAFE_FORCE_platform_id;
};

/**
 * Rendition page opened from vendor iframe when Safari disable third party cookie
 * JIRA C150113-51278
 */
export const isOpenedFromCitisBest = window.HTML_RENDITION.initialData.urlParameters?.citis_best == 'true' || false;
export const __epftoken = window.HTML_RENDITION.initialData.urlParameters?.__epftoken || '';

const getPORTALTTokens = () => {
    try {

        return getEPFTokensForGeneral();

    } catch (e) {
        console.log(e);
    }
    return undefined;
};

// Common condition method to work on third party token authorization
export const isThirdPartyTokenAuthorization = () => {
    if (!isAppInsideIFrame()) {
        return false;
    }
    const tokens = getPORTALTTokens();
    if (tokens?.tokenWrapper) {
        return true;
    }
    return false;
};

export const tokenAuthorizationForThirdParty = (func: any) => {
    const tokens = getPORTALTTokens();
    return tokens?.tokenWrapper(func);
};

export const getRequestToken = () => {
    const tokens = getPORTALTTokens();
    return tokens?.getRequestToken();
};

export const openLinkNewWindowByTokenAuthorization = (docUrl: string, target='_blank') => {
    try {
        if (isThirdPartyTokenAuthorization()) {
            const f = (token: any) => {
                docUrl = addParam(docUrl, '__epftoken', token.access_token);
                window.open(docUrl, target);
            };
            const tokens = getPORTALTTokens();
            tokens?.tokenWrapper(f);
        } else {
            window.open(docUrl, target);
        }
    } catch (e) {
        window.open(docUrl, target);
    }
};

export const openInCurrentWindowWithCallback = async (requestUrl: string, callBackFunc: (resp: any, token: any) => void, customHeader: any = {}) => {
    try {
            const token = await getRequestToken();
            const options = _.merge(
                customHeader,
                {
                    headers: {
                        'Authorization': `bearer ${token.access_token}`
                    }
                }
            );
            fetch(requestUrl, options).then((resp) => {
                callBackFunc(resp, token);
            });
    } catch (e) {
        fetch(requestUrl, customHeader).then((resp) => {
            callBackFunc(resp, null);
        });
    }
};

export const executeWindowOpenForEPFToken = (url: string) => {
    if (!isAppInsideIFrame()) {
        return false;
    }
    const current = new URL(window.location.href);
    if (url && current.searchParams && current.searchParams.has("__epftoken")) {
        openDocWithEPFToken(url);
    }
};

export const openDocWithEPFToken = async (url: string) => {
    const requestUrl = url;
    const callBack = (resp: any, token: any = {}) => {
        let authLink = resp.url;
        if (!_.isEmpty(token)) {
            authLink = addParam(authLink, '__epftoken', token.access_token);
        }
        window.location.href = authLink;
    };
    openInCurrentWindowWithCallback(requestUrl, callBack);
    return;
};
export const wrapperUrlwithEPFToken = async (docUrl: string) => {
    try {
        if (isThirdPartyTokenAuthorization() && docUrl) {
            const f = (token: any) => {
                docUrl = addParam(docUrl, '__epftoken', token.access_token);
            };
            const tokens = getPORTALTTokens();
            await tokens?.tokenWrapper(f);
            return docUrl;
        } else {
           return docUrl;
        }
    } catch (e) {
      return docUrl;
    }
};
export const getURLData = (source: string, url?: string) => {
    // Remove the last "#/" from location url
    const currentUrl = url ? url.replace(/#\/$/, "") : window.location.href.replace(/#\/$/, "");
    console.log("currentUrl :: " + currentUrl);
    let urlString;
    let urlParams;
    let user_data;
    let doc_data;
    let doc_data_extn;
    let decoded_doc_data;
    let encoded_doc_data;
    let temp_doc_data;
    let temp_doc_data_extn;
    const {
        copyTextUrlPlatform,
        copyTextUrlVendor,
        copyTextUrlChannel,
        copyTextUrlSubChannel,
        copyUrlPlatform,
        copyUrlVendor,
        copyUrlChannel,
        copyUrlSubChannel,
        doc_id
    } = window.HTML_RENDITION.initialData;
    let copy_url_platform_data = '';
    if (source === 'copyTextUrl') {
        copy_url_platform_data = "&platform=" + copyTextUrlPlatform + "&vendor="
            + copyTextUrlVendor + "&channel=" + copyTextUrlChannel + "&sub-channel=" + copyTextUrlSubChannel;
    } else if (source === 'copyLHS') {
        copy_url_platform_data = "&platform=" + copyUrlPlatform + "&vendor="
            + copyUrlVendor + "&channel=" + copyUrlChannel + "&sub-channel=" + copyUrlSubChannel;
    }
    if (currentUrl.indexOf("/rendition/eppublic/documentService/") >= 0) {
        urlString = currentUrl.split("/rendition/eppublic/documentService/");
        urlParams = urlString[1].split("/");
        if (urlParams.length == 2) {
            user_data = urlParams[0];
            doc_data = urlParams[1];
            if (doc_data.indexOf("?") >= 0) {
                temp_doc_data_extn = doc_data.split("?");
                doc_data = temp_doc_data_extn[0];
                doc_data_extn = temp_doc_data_extn[1];
                if (doc_data_extn.indexOf("#") >= 0) {
                    temp_doc_data_extn = doc_data_extn.split("#");
                    doc_data_extn = temp_doc_data_extn[0];
                }
            }
            if (doc_data.indexOf("#") >= 0) {
                temp_doc_data = doc_data.split("#");
                doc_data = temp_doc_data[0];
            }

            try {
                decoded_doc_data = Base64.decode(doc_data);
            } catch (e) {
                doc_data = doc_data.replace('-', '+');
                decoded_doc_data = Base64.decode(doc_data);
            }
            if (decoded_doc_data.indexOf(copy_url_platform_data) < 0) {
                doc_data_extn = typeof doc_data_extn !== 'undefined' ? '?' + doc_data_extn : '';
                decoded_doc_data = "doc_id=" + doc_id + copy_url_platform_data + doc_data_extn;
            }
            return urlString[0] + "/rendition/eppublic/documentService/" + user_data + "/" + Base64.encode(decoded_doc_data);
        }
        if (urlParams.length == 1) {
            doc_data = urlParams[0];
            if (doc_data.indexOf("?") >= 0) {
                temp_doc_data_extn = doc_data.split("?");
                doc_data = temp_doc_data_extn[0];
                doc_data_extn = temp_doc_data_extn[1];
                if (doc_data_extn.indexOf("#") >= 0) {
                    temp_doc_data_extn = doc_data_extn.split("#");
                    doc_data_extn = temp_doc_data_extn[0];
                }
            }
            if (doc_data.indexOf("#") >= 0) {
                temp_doc_data = doc_data.split("#");
                doc_data = temp_doc_data[0];
            }
            try {
                decoded_doc_data = Base64.decode(doc_data);
            } catch (e) {
                doc_data = doc_data.replace('-', '+');
                decoded_doc_data = Base64.decode(doc_data);
            }
            if (decoded_doc_data.indexOf(copy_url_platform_data) < 0) {
                decoded_doc_data = decoded_doc_data + copy_url_platform_data;
            }
            encoded_doc_data = Base64.encode(decoded_doc_data);
            if ((typeof doc_data_extn !== 'undefined') && (doc_data_extn.indexOf("vendor-issuer") < 0)) {
                return urlString[0] + "/rendition/eppublic/documentService/" + encoded_doc_data + '?' + doc_data_extn;
            } else {
                return urlString[0] + "/rendition/eppublic/documentService/" + encoded_doc_data;
            }
        }
    } else if (currentUrl.indexOf("/rendition/eppublic/uiservices/open_document") >= 0) {
        urlString = currentUrl.split("/rendition/eppublic/uiservices/open_document");
        decoded_doc_data = "doc_id=" + doc_id + copy_url_platform_data;
        encoded_doc_data = Base64.encode(decoded_doc_data);
        return urlString[0] + "/rendition/eppublic/documentService/" + encoded_doc_data;
    } else if (currentUrl.indexOf("/rendition/eppublic/service/openTimedLink") >= 0) {
        urlString = currentUrl.split("/rendition/eppublic/service/openTimedLink");
        decoded_doc_data = "doc_id=" + doc_id + copy_url_platform_data;
        encoded_doc_data = Base64.encode(decoded_doc_data);
        return urlString[0] + "/rendition/eppublic/documentService/" + encoded_doc_data;
    }
    return currentUrl;
};

export const handleOffTheCuffSubTitle = (subtitle: string, isObject?: boolean) => {
    const splitFlag = '(Post';
    const pubTitleArr = subtitle.split(splitFlag);
    if (isObject) {
      return [{
        tag: 'p',
        class: 'mb-0',
        data: [
          { tag: 'span', text: pubTitleArr[0] },
          { tag: 'span', class: 'post-count', text: splitFlag + ' ' + pubTitleArr[1] },
        ],
      }];
    }
    return <p className='mb-0'><span>{pubTitleArr[0]}</span><span className="post-count">{splitFlag + ' ' + pubTitleArr[1]}</span></p>;
};

export const setTargetValue = (str: string) => {
    // for the url link, if the page is opened as an iframe in CVResearchUI, then the url should be opened in its iframe page; if not the url will be clicked to open a new page
    let targetValue = '';
    if (isCVLink(str) && isAppInsideCVResearchUIiFrame() && !isCV2Link(str)) {
        window.HTML_RENDITION.initialData.productType === 'blog' ? targetValue = '_parent' : targetValue = '_self';
    } else {
        targetValue = '_blank';
    }
    return targetValue;
};

export const toggle_on_icon = 'data:image/png;base64,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';
export const toggle_off_icon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAA+CAYAAAAIyajNAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABBqSURBVHhe7Zz7cxzVlcdPv7unZ0YzGsmSLdnGQGyEnXKwk2CzxoSASaAqdhIqUFvwO38GxZ+Bq/iJFD9AfsiShdqFJQZhL2TjxIIYZyFZW5Zl2XrNu9+vPad7rt2ZCGskS7Y8mq99dbt7prvv3PO555zb3TPQU0899dRTTz311FNPPfXUU0+3J65Vr7vefvtteXR0dNCJoqJtWXJgB5zneUD/ukqtj/PPn6rTzymBJOFf/JORpCCTydQ5jps/cuRIo/WGddO6wvD+++8rmqYVTdPM50ul/u3btz8R+sFRz/W3uL7H+UEIYRgAhK0d7hG1NzeKIraE/8N4Pd6Cbwzj5Zvb43fRAXA5OQ7bF8VxIPAccLyAMAggS6Iry8rXkij8furSpT9bFjQHBvTKoUOH6q091lTrAgNBwOl6/8jg4H35fOGY49iHbMcZkEW5mMloo5qiiIoic5IkgiAI2AfYAa197wUlNm0ZnOzcMngUYkFLh3GNxg4JAFpPQLhZJ6/Hx2AstDogfh0Hief7WILIcR3Dcbxp3FrVNf2SKsu/n5+vnG42F+eefvpp8hrsCLetNbUBQYBVfucDD9yvafpPLMt8LIq47xQL+dF8VucVRcG2czxPfxEApvTyRldixBYAbctkbFZoPQiCeJnV6ddY3S7qi7jwPGA/0XL8dsd1o4Zp2qZhXcR+PJ/LZT5s1mqfzM7Ozj3zzDMmva91iFVrzaxAOcHRo0f3BBH3bKVaO4qHfmjLYHE0n8sJAs8LvCDEJr+XDN8uZjyq2XK7ccnwaQjSxfUDsP0Q6wg89A448JNQgYeibsEIASL+kQUsIgeKiOFC4GPvif1Hxop8jKvVetOq1xp/RyC+Ghgovbs4N/fRvn37ynGDbkNrYhkC4cChQ7tDP/wl5gMn+vLZMfQGkiLLIo+E38sAMKVBYHUahHbDU/FjV++D6QbQdAKYM0O43IzgSpODOZuDmgtg+hzmFYC5AkBGiKBPBhjSItiRjWBnloMtGR50RQANcwhKKgkKOr3vBX6lVjVt1/+0WMi9WZ6f/+jRRx9djBu3St22lV5//XXp2WdPPFRp1I5j0vOroYHSWD6XlVku0A26FQhkdFomwzMAqLg4U7JcH+q2D39ZjGBikYNLCIGBxkfnAOgUYgjClAk4dBHkHdAxADoGyEkRPJiP4JFSBPtKPOQQCgXzLIJCFEVKTqNGw2jOlsvjhWzuzWp5/oPHH3+80jrcinVb1jp79qxUGh7eW6vWT2Qz+vHBgf69ekZTCIRuEQOARMvfBkLsBWiqjMVxPahaPnxVDuHzOYKAhybOLF2EIFpRl0cgo8fI4VTzO7kQDg9F8HA/D30aTT+TQm8ybac5t7j4ia4qv3Ys66ODBw8uriaHWLXVyCPse+SRh2vV5vOFfP4XWwb6x3Q9sylBIABib+C6YCMI82j5/7wSwX9d42ESQTB8AD8iCFY69jj0IBxYAQezFgcXGxzYXgBDSgASn2CFYZjDKaisKvK2crVRUHXNmJ6aunby5EkzOUbnWpVnOHXqlLh///6HJ6ev/zyf158f7O/fndUzKuUH3SQGAwOBwUDlRk7Q8gYuQmA6LlyuevAf0xxcqPGYE2A+sLouXlIURvowdBwohfDT0QhG8hIgBCDLcjzrQA/RmJlb+LS/r+/XoWd/sNKkclUtdRxn36XLV54XROnEQH/hoVwuq+GMofVqdygNAqsZBMwjMG9AxbAdmKz68O9TBIIQe4OVhYTOlRUj2F8M4Gc7ItjeJyIQSgIEz0e1htGo1xvjW7duedOz7Q927dpVbe22rFZsQQoP09dmD0UcR7OGh3JZvetAaBcDgeo0FIlHwNDgOHC9kXiErxCE5jqCQGpiEjpR4eG9KwALRtIGaguekevL6Tn0FkfLldqvyuXyjtYuHWlFVsSO4F544YXv1hqNH2DCOBqD0EU5AhMZnNXpQhCkvQILD/PoBj69BnC+yuNUkfZcPxCYaFbyRUWAU1cBqmbinag9dEGviKPUNu29Wi535Msvvyy2dllWK4IBkxJxdr58KKvrWLSCgq5pM4jBwTwC8wpUarYHXy2G8IcFERoeRfX1ByERF5/vv+dFOI/nN5ykPQSpLEtcPqfvdB3/WNNxRls7LKuOYXj11Vf5l156aZ/pWAdx1rAVi9Qt1xHSYoZvF/MKLHGM8wXs/EV0BX9c4KGMyeKdAyERnY/O+9m8ABVsBwMUPwOX78upfuDvKRaLhy9cuFBq7XJLdQzDtm3bhIVy7V80VT2oKXJe7MLwkBYLDawwGKgwGGqWB19XIrjYFOKLSHdDPp73//D8/1uNYu/A2ob24TKauj1wg6fqtt2Rd+gYBtu2+cVy5QE9o29DIOiOU+uV7hYDgdXpMFG2wjhuG8Gd9wo3xcUJ5RdlHup24rWofVEYcnpGyziet8dsWgOtN99SHcFAIeLll1/ejV2yRdNUuXXlq+u1lGdgMNDFn+tmBJdNIb6sfDdFXmnSEGEW20M3wwgIaivmdDRkswMDxbFOEsmOYKAQYXreY7qmjUmCoHTrVJKMzmq2TGqHgTrbcEO4atKo5O+iV2DioI7tmGoCWO7NG2XUKlkSB3lOOCKo6n3Je79dHVmVQoTZNPdomrJDkkS1tbnrxaBghQFBpYEwTBvJHceNIPIOU9gew0uApTaiOFmWc1EY7TVrza3xG2+hleQMmiRK6Bi6O3FMaykQ2KizsNMXXfIKG0ME5bzDx+1i7aQaYzoEYagatrPsIO4YBtP14rtkmwkG0rcB4eBQrHkbBwZqR9UTwMHpBQOBHq+jZymjEOF1l79v1TEMHsIgikL8KNZmVRoMHzvaCqj7NkZ/UN5C7aF2EQjURtpKgzfAZZxiJm+8hTqGgR7S7JanllaqNASsYH/Ht5c3kpIHZv6xnTR4cSn2FsupYxjwNEm1ST1DuoOp0Kjj1+7B5DVQ8pQUNi5ZY22NV+JNy6pjGMgr0KPg7GSbXQKCIPPUFxujP4gDhUfv3TZWI3Rh8fjtINXrGAZKHn2fEpPNCQOFx3SIlBAGXVje9d4pUcty2B6CNK2Awju+2kni3zEMCsLg+V6cnGw2MRDSRcG+LYr+Bkkf0ZAIQUny42cmb7QTvTk9nc3zAsjC8neYO4ZB1TQPDxx2koh0q6iDKVxS0RCGIWXjwEDjfljxQMUFluhT2+jOKi9ynq6ry47ijmBQVTXMZrQp27ar6B02nWu4MdJahTpblwBGVA9HInXH3Q6dEXqqEEY1HzTxJrD0guu4Ng/CVEbRl338rSMYZmZmAl1TPjMt+y9+EBhJNt39WgoCir1UFJGHYRxsw7J7170DeYWt2I5BFaGQEhBaOUJke95sCMEnmiZdpg23UkcwvPbaa+HZs2cnEIRpBALzyM0RKpaCgRX6EktR4WCPbsfJ5N0TzWpC2K07kMOEgZ4zIRCoja7n04UH4/q1uS+uXbt2pbXDt6rjnGFyctItFXJThmHVMVx0Zaggg7O6fZl1MPMMVPIIw1jWhaHYO9wdIAQ8L3mnPdiOLMGAkFLbsM2RYVqepMhXVUmuPfnkk/HTmbdSxzBQqCiWSp81LeMceocmXenqdjEgSLTMYKAOp0I3gbZoHOzPGqDGucOdFQGYwVzhe1kT+lWeblffgAGtE5mONS1w/Me5weLV1i63VMcwUKg4/fHHf9Qk9fNm01gwTQtTh+4HgoWFNAxpIOj7j/vyLoxpBoaLO5lMYn6AAI5lDBjLe3E7WJvIKzQN0xc48VLdqI//z/h4RzDEWUaneuutt3wQOG5hobIDT7qdvldJHdSNSnuFNPTsJhArtC6DD3nOgVlXgIYvrum3qJYW5gmYp9ynWvBUqQlbdR4ymkqzPpAkup7ARQuL1SlNU34bus74iRMnOvoy7oosScR9fvr0nzJZ9Q+NZrNcb9LEoru8QxoCJuYVmGdgI5CuyiqKEn+jaUQHeKJQx/jtYKeuZ58kIIzINjxeaMBQhgNNVeJ2UHt4novqjaanKPIls2mOnzt37nprx2W14mF9/Phxc7hUOh1E0YeVSnXGsuyuA6JdBAMr6TBBX2ljQODUGx7MhfDjQhV2yCZI7MbeGopyBAVD0S7FhB8Va7ArF0EWz3sTBD4yLde1XGcim8u+x3HypVdeeaXjX1BbUZhgQiAWt41sqyyUq+iTohEcGVnsIOyr9XaPd0bsc9zq89Br7YOAflehT/RgSLTA9iOoByIGEDrG7fZLFI9anQ9gb6YBT/Q3YFeeg3xGAU3TYhgQzsgLQnexWpnQNP2dSIB3A9e4evLkyY6pXBUMb7zxhv+vL7441z/QXy1X6xmeg2FFlrsKiNWIPjuFCLqBNSjaoHIemAEPdii0/MRK+yZ51FZGb7BVsuD7uToc6LNgNCvEHoFyhJZXICzdhUplAnOG30Se8943f/3r5LFjxzr2CqTbstzExISeyRUfMyzzxVKx7yeD/f0j9Ctu3QIEG/lUs8IeKaOanpKm70+wb2I7jnOjWLYNFSuA6xbAN4YKF+0MzAcqeFF7RsH66uZW2kJF4QL0MjbswkTxQd2BITWCoiYiBAkIrTAV+UHgVhvNLzBfeAcb9buFhYXJ5557zokPtgLdttUIiL5S6QfVWuPFfDb3s6HB0ghltt0ARDoMMBgIBAYDA2IpKG7AgXXVDmHRBpxtiHDNkWHBk6EWSmBgcWM4Eo8io/F13oeC4MKgRBezPNiiBNCvQHwdAQdaDAB5A6oFQYxsx3FrjcaEKEjviHz0b2fPnr28kjwhrTWxGDYgUxoa+qHRtF5SFOmnhXzfSLGQ5yjRupeVhoHEYGD1UkAwKNrr5DeeAmigmegbUKbPIwgcegrKPdAQaAkRZwkKTxeSMDEUo/g3nTKycCNRZTXlB7SDYWC26AUToiz9JnTD35079/nF1YJAWrPhS0Ds3Lnz0VrT/KXtOk9osjZS6u8r5nLZ2Efcq54iDQQtpwsDgmoGRBoKtpyuqaT3Y8dn/ZO+sEWFTWGpJgg4jgfTsjzTcWZkUb6s6eq7eNB3z5w5s2qPwLSmFjp//nw2n8/f5/jRAUT2KV7kvq+p6tZcJlPI6hmOPtS9CAUzGCkNAxUyKDMu8xLt3iK9nRW2HzsmifomfT2DwUDrdHPQdlzH88NZgecm8e3jtmufGSqVvpmZmZnq5N7DcloXy5w6dSp7//179liO9b0win4kiPwBkRfyiqpkZEkq4FSUp58KFgX8oMLNBzE2spjBSGkYqDDDpqFoL+0egQrb/x9EgwU3ha2fHfaD0ArCsIqbLOypGdzjtO+7n5UKQ1+Pj394W2GhXetqAwodw8Pbd5fri7t8NxrWdOUgkv5DNH4fnjhGgLpio4PQLjRIUpMhY8MxKGgFjY2GpO8qxEaPnxul9cS4UUAQYCEYWsdJKx4YGAqSnwvmXVy9jACdqRmNv5VyxYViMfe36enpybXwBO26Y3ag35U+fPjwWMM0xxoNo2CYFmf7GEftNQP7jgnN21pCxYtk8HgtVvw6/WI+reCfEL0BLeCm5FX2whKikEDhlGYMmYzqZ3V9tj+fvzA6Ovp3BOWf6empp5566qmnnnrqqaeeerrr4nAO25uu9IQC+H9kGYVphs+JagAAAABJRU5ErkJggg==';

export const getDisclosureHtmlFromService = (docId: string) => {
  let disclosureRequestUrl = `${getContextPath('html')}/Disclosure_${docId}.html`;
  const adaText = buildAdaAltText('', '');
  return new Promise((resolve, reject) => {
    const epfToken =  getStaticEPFAccessToken();
    if (!isEmpty(epfToken)) {
      disclosureRequestUrl = disclosureRequestUrl + `?__epftoken=${epfToken}`;
    }
    axios.get(disclosureRequestUrl)
    .then((response: any) => {
      if (response.status === 200) {
        const wrapHtml = $(`<div>${response.data}</div>`);
        wrapHtml.find('table').removeAttr('id').attr({'aria-label': adaText, 'role': 'table', 'tabindex': 0});
        wrapHtml.find('img').attr({'role': 'img', 'tabindex': 0}).each(function (){
            const $this = $(this);
            $this.attr('alt', $this.attr('alt') + ' ' + adaText);
        });
        if (!isEmpty(epfToken)) {
            wrapHtml.find('img[src*="authfilelinksvcs"]').each(function (){
                const $this = $(this);
                let authFileLink = $($this).attr('src') || '';
                if (!isEmpty(authFileLink)) {
                    authFileLink = addParam(authFileLink, '__epftoken', epfToken);
                }
                $this.attr('src', authFileLink);
            });
        };
        $('#disclosures').on('keydown', (e) => {
            const key = e.keyCode || e.which;
            if (key === 13 || key === 32) {
                if ($(e.target).is('img')) {
                    $(e.target).click();
                }
            }
        });
        wrapHtml.find("a").each(function (){
            const $this = $(this);
            if (!isCVLink($this?.attr('href') || '')) {
                $this.attr('target', "_blank");
            }
        });
        resolve(wrapHtml);
      } else {
        console.error(response);
        reject(response);
      }
    }).catch((error: any) => {
       console.error(error);
       reject(error);
    });
  });
};

export const onAuthorSelection = (name: string) => {
    showLoadMask();
    
    try {
        fetch('/rendition/eppublic/uiservices/getAnalystInfo?analystId=' + name + '&ts=' + new Date().getTime())
        .then((response) => response.json())
        .then((response) => {
            const analystData: any = response;

            if (_.isNull(analystData) || _.isUndefined(analystData) || _.isEmpty(analystData) ) {
                console.log('getAnalystInfo no analystData for: ' + name);
                hideLoadMask();                
                alert('Not found analyst page!');
                return;
            }

            const analystStatus = analystData[name].analystStatus;
            if (!analystStatus || analystStatus.toUpperCase() !== "OK" ) {
                console.log('analystData.analystStatus: no analyt status OK found:: ');
                hideLoadMask();                
                alert('Not found analyst page!');
                return;
            }

            const analystNumber = analystData[name].analystNumber;
            if (!analystNumber) {
                console.log('analystData.analystNumber: no analystNumber found::');
                hideLoadMask();                
                alert('Not found analyst page!');
                return;
            } else {
                console.log('analystData.analystNumber: analystNumber found::', analystNumber);
                hideLoadMask();                
                openAnalystPage(analystNumber);
            }
        });
    } catch (error) {
        console.error('ERROR:: onAuthorSelection=', error);
        hideLoadMask();        
        alert('Not found analyst page!');
    }
};

export const openAuthorPageFromEmail = (authorsArr: Array<{displayName: string, analystId:string}>) => {
    if (window.HTML_RENDITION.initialData.openAuthor === 'true' && !window.HTML_RENDITION.initialData.isDeaden("ANALYST_NAME")) {
        for (const element of authorsArr) {
            if (element.displayName === window.HTML_RENDITION.initialData.authorName) {
                onAuthorSelection(element.analystId);
            }
        }
    }
};

export const toggleToShowHTML = (showingHTML: boolean) => {
    if (!showingHTML) {
        commonStore.dispatch(htmlPDFtoggleStatus(true));
    }
};

export const isCV2Link = (url: string) => {
    return url.indexOf("/cv2/go/") > -1;
};

export const isPremiumBranding = (data: object) => {
    const initialData = window.HTML_RENDITION.initialData;
    if (initialData.isFAVE) {
        return !_.isEmpty(_.get(data,"branding.data",[]));
    } else {
        const brandingIcons = ["showFLS","showMustC","showSRI","showSeries","showInl","showSSA"];
        let isPremiumIconShow = false;
        each(brandingIcons,icon => {
            const isPresent = get(data,`metadata[${icon}]`,false);
            if (isPresent){
                isPremiumIconShow = isPresent;
            }
        });
        return isPremiumIconShow;
    }
}

export const getCwStvTitle = (title: any) => {
    const docHeaderSectionJson = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    let cwStvTitle = docHeaderSectionJson.i18n.catalystWatch;
    //if the title is not short term view, it will be catalyst watch so default title is set to catalyst watch
    if (!isEmpty(title)) {
      if (title === "Short-Term View") {
        cwStvTitle = docHeaderSectionJson.i18n.shortTermView;
      }
    }
    return cwStvTitle;
}

export const isFigureGalleryPopup = (modalTitle: any, figureGalleryHeaderJsonValue: any = '') => {
    if(isEmpty(figureGalleryHeaderJsonValue)) {
        return isEqual(modalTitle, 'Figure Gallery') ? true : false;
    }
    return isEqual(modalTitle, figureGalleryHeaderJsonValue) ? true : false;
}